import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderRadius: 8,
  },
}));

const ModalImageCors = ({ imageUrl, onLoad, style }) => {
  const classes = useStyles();
  const [blobUrl, setBlobUrl] = useState("");
  const [fetching, setFetching] = useState(true);
  const imgRef = useRef();

  useEffect(() => {
    if (!imageUrl) return;

    const fetchImage = async () => {
      try {
        const { data, headers } = await api.get(`/obter-arquivo/${imageUrl}`, {
          responseType: "blob",
        });
        const blob = new Blob([data], { type: headers["content-type"] });
        const url = window.URL.createObjectURL(blob);
        setBlobUrl(url);
        setFetching(false);
      } catch (error) {
        console.error("Erro ao buscar imagem:", error);
      }
    };

    fetchImage();
  }, [imageUrl]);

  return (
    <>
      {/* Imagem invisível só para capturar o evento onLoad */}
      <img
        ref={imgRef}
        src={blobUrl}
        style={{ display: "none" }}
        onLoad={onLoad}
        alt="preview"
      />

      {/* ModalImage visível para o usuário */}
      {!fetching && (
        <ModalImage
          className={classes.messageMedia}
          smallSrcSet={blobUrl}
          medium={blobUrl}
          large={blobUrl}
          alt="image"
          hideDownload={true}
          hideZoom={false}
          style={style}
        />
      )}
    </>
  );
};

export default ModalImageCors;
